import { formatDateToUtc } from '@/core/helpers/date-format';
import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        modelValue: [String, Date],
        placeholder: String,
        disabled: Boolean,
        type: {
            type: String,
            default: 'date'
        },
        disabledDate: Function
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const dateType = computed(() => {
            return props.type === 'datetime' ? 'DD MMM YYYY HH:mm:ss' : 'DD MMM YYYY';
        });
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', formatDateToUtc(value));
            }
        });
        return { value, dateType };
    }
});
